import React from 'react';
import { useDashboardStore } from '../stores/dashboardStore';
import './Footer.css';

const Footer: React.FC = () => {
    const { config } = useDashboardStore();

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-content">
                    <div className="footer-section">
                        <h3>About Me</h3>
                        <p>{config.personalInfo.description}</p>
                        <div className="contact-info">
                            <p>📧 {config.footer.contact.email}</p>
                            {config.footer.contact.linkedin && (
                                <p>
                                    <a href={config.footer.contact.linkedin} target="_blank" rel="noopener noreferrer">
                                        💼 LinkedIn
                                    </a>
                                </p>
                            )}
                            {config.footer.contact.github && (
                                <p>
                                    <a href={config.footer.contact.github} target="_blank" rel="noopener noreferrer">
                                        💻 GitHub
                                    </a>
                                </p>
                            )}
                        </div>
                    </div>

                    <div className="footer-section">
                        <h3>Internship Experience</h3>
                        <div className="company-logos">
                            {config.footer.companyLogos.map((company, index) => (
                                <a
                                    key={index}
                                    href={company.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="company-logo-link"
                                >
                                    <img src={company.logo} alt={company.name} />
                                    <span>{company.name}</span>
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="footer-section">
                        <h3>Quick Navigation</h3>
                        <nav className="footer-nav">
                            {config.navigation.mainNav.map((nav) => (
                                <a key={nav.id} href={nav.path} className="footer-nav-link">
                                    {nav.title}
                                </a>
                            ))}
                        </nav>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="statement">
                        <p>{config.footer.statement}</p>
                    </div>
                    <div className="copyright">
                        <p>&copy; 2024 {config.personalInfo.name}. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;










